import { FC } from 'react';

interface OmOssProps {
  onRequestDetails: () => void; // passed from Carousel
}


const OmOss: FC<OmOssProps>= ( { onRequestDetails } ) => {

  return (
    <div className="slide-item-inner">
      <h2 className="slide-item-title title">Kärleksfull biodling</h2>
      <p className="text-lg text-green-dark/100">
            Passionerade biodlaren Juan Cerón som fick hela familjen att vilja biodla.
      </p>
      <div
        className="slide-item-learnmore button"
        onClick={onRequestDetails} // 👈 trigger detail view
      >
        LÄS MER
      </div>

      {/* New container for the image */}
      <div className="image-container">
        <img
          className="slide-item-background"
          src="/pictures/honeypictures/biodlare/beekeepers1warmrounded.webp"
          draggable="false"
          loading="lazy"
          alt="Bikupor"
        />
      </div>
    </div>
    
  );
};

export default OmOss;
